import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
  Typography,
} from "@mui/material";
import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import formatDate from "../../util/dateFormat";
import axios from "axios";
import { APIConstants, APIModuleConstants } from "../../constants/ApiConstants";
import InfiniteTable from "../Table/InfiniteScroll/InfiniteTable";
import useGetTotalRecords from "../../Hooks/CustomHooks/UseGetTotalRecords";
import DownloadForOfflineRoundedIcon from "@mui/icons-material/DownloadForOfflineRounded";
import theme from "../../theme";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import useButtonStyles from "../../styles/useButtonStyles";
import useDebounce from "../../Hooks/CustomHooks/debouncng";
import { formatDateReport, getEncodedValue } from "../forms/utility";
import { operatorConstants } from "../../util/SearchandFIlters/Constants";
import { getHashURL } from "../../util/SearchandFIlters/searchAndFilter";
import SearchInput from "../../Shared/Components/SearchInput/SearchInput";
import {
  SearchToolTip,
  hashKey,
  hashValue,
  DateConstants,
  modelName,
} from "../../constants/AppConstants";
import ExportDialog from "../../Shared/Components/ExportDialog/ExportDialog";
import { exportData } from "../../services/ApiServices/export";
import { usePermissionGetter } from "../../Hooks/Permissions/userPermissionGetter";
import { CommonButton } from "../../Shared/Components/Buttons/CommonButton";
import { DualInputProps } from "../../pages/SharedContents/InputProps";
import useDateFilter from "../../Hooks/Filters/useDateFilter";
interface TableColumn {
  key: string;
  header: string;
  searchable?: boolean;
  filterable?: boolean;
}

const OrderDate = "order_date";
const Earnings = () => {
  const { getUserPermission: getSalesListingPermission } = usePermissionGetter(
    "finance",
    "sales_listing",
  );
  const buttonStyles = useButtonStyles();
  const [earningsData, setEarningsData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openExport, setOpenExport] = useState(false);
  const { totalCount, getTotalRecordsCount } = useGetTotalRecords();
  const searchInputRef = useRef<HTMLInputElement>();
  const currentDate = formatDateReport(new Date().toISOString());
  const [exportEmail, setExportEmail] = useState("");
  const [sending, setSending] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const [validEmail, setValidEmail] = useState(false);
  const [visited, setVisited] = useState(false);
  const [lastKey, setLastKey] = useState<any>(null);
  const [isInitialApiCall, setIsInitalApiCall] = useState(true);
  const [openFilter, setOpenFilter] = useState(false);
  const [filterActive, setFilterActive] = useState(false);
  const { selectedDates, onUpdateFiltedDate, onResetDate, valueWithOperator } =
    useDateFilter([OrderDate]);
  const debounceSearch = useDebounce();
  const sourceList = ["e-voucher", "flash-sale"];
  const statusList = [
    { key: "Success", value: "00" },
    { key: "Fail", value: "11" },
  ];

  const columns: TableColumn[] = [
    { key: "orderId", header: "Order ID" },
    { key: "transactionNumber", header: "Transaction No" },
    { key: "loyaltyNumber", header: "Loyalty Card No" },
    { key: "type", header: "Type" },
    { key: "totalAmount", header: "Total Amount" },
    { key: "totalOrder", header: "Total Orders" },
    { key: "orderDate", header: "Order Date" },
    { key: "orderStatus", header: "Order Status" },
    { key: "failureReason", header: "Failure Reason" },
  ];

  const metaData = {
    orderId: {
      isImage: false,
      linkTo: "",
    },
    orderCode: {
      isImage: false,
      linkTo: "",
    },
    memberName: {
      isImage: false,
      linkTo: "",
    },
    totalAmount: {
      isImage: false,
      linkTo: "",
    },
    orderDate: {
      isImage: false,
      linkTo: "",
    },
    payoutStatus: {
      isImage: false,
      linkTo: "",
    },
    payoutDate: {
      isImage: false,
      linkTo: "",
    },
  };

  const [filterStates, setFilterStates] = useState<any>([]);

  const getAllFields = (fieldValue: any, value: any, operator?: any) => {
    const existingObject = filterStates.find(
      (obj: any) => obj.fieldValue === fieldValue,
    );

    if (!existingObject) {
      setFilterStates((prev: any) => [
        ...prev,
        { fieldValue: fieldValue, value: value, operator: operator },
      ]);
    } else {
      setFilterStates((prev: any) =>
        prev.map((obj: any) =>
          obj.fieldValue === fieldValue
            ? { ...obj, value: value, operator: operator }
            : obj,
        ),
      );
    }
  };

  const bindSearchAndFilter = (canHaveExistingData?: boolean) => {
    const url = getFilterParams();
    getEarnings(url, canHaveExistingData);
    setIsInitalApiCall(false);
  };
  const getFilterParams = () => {
    const value = searchInputRef.current
      ? getEncodedValue(searchInputRef.current?.value)
      : "";
    const searchParam = value !== "" ? [value] : [];
    const filterValues = [...filterStates, ...valueWithOperator];
    const params = {
      searchData: searchParam,
      filterData: filterValues,
    };
    const url = getHashURL(params);
    return url;
  };
  useEffect(() => {
    if (isInitialApiCall) bindSearchAndFilter();
  }, [isInitialApiCall]);

  const onReset = () => {
    setEarningsData([]);
    setLastKey(null);
  };
  const handleSearch = () => {
    onReset();
    setIsInitalApiCall(true);
  };

  const handleApply = () => {
    onReset();
    setIsInitalApiCall(true);
    setOpenFilter(false);
    const generatedURL = getFilterParams();
    const searchParams = new URLSearchParams(generatedURL);
    const filtersValue = searchParams.get("filters");
    filtersValue && setFilterActive(true);
  };

  const handleClose = () => {
    setOpenFilter(false);
  };

  const getEarnings = async (
    urlString?: string,
    canHaveExistingData?: boolean,
  ) => {
    let currentURl = `${process.env.REACT_APP_API_URL}${APIConstants.getAllSales}?limit=50`;
    if (urlString) currentURl += `&${urlString}`;

    try {
      setLoading(true);
      getTotalRecordsCount(APIModuleConstants.salesListing, urlString);
      if (lastKey) {
        currentURl += `&lastKey=${encodeURIComponent(JSON.stringify(lastKey))}`;
      }
      const deals = await axios.get(currentURl);
      const data = deals.data.Result;
      setLastKey(deals?.data?.lastKey);
      const mappedData = data.map((earning: any) => ({
        orderId: earning.order_id ? earning.order_id : "-",
        loyaltyNumber: earning.loyalty_number ? earning.loyalty_number : "-",
        itemName: earning.item_name ? earning.item_name : "-",
        merchant: earning.merchant ? earning.merchant : "-",
        totalAmount: earning.total_amount ? earning.total_amount : "-",
        orderDate: earning.order_date ? formatDate(earning.order_date) : "-",
        totalOrder: earning.total_order ? earning.total_order : "-",
        totalSales: earning.total_sales ? earning.total_sales : "-",
        orderStatus: earning.status
          ? earning.status === "00"
            ? "Success"
            : "Fail"
          : "-",
        type: earning.type ? earning.type : "-",
        transactionNumber: earning.transaction_number
          ? earning.transaction_number
          : "-",

        totalOpenOrder: earning.total_open_order
          ? earning.total_open_order
          : "-",
        navigateTo:
          earning.status === "11"
            ? ""
            : `${"/salesListingDetails/"}${earning.order_id}`,
        failureReason:
          earning.type === "PAYMENT" && earning.failureReason
            ? earning.failureReason
            : "-",
      }));
      let completeData = canHaveExistingData
        ? [...earningsData, ...mappedData]
        : mappedData;
      setEarningsData(completeData);
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  // const handleReset = () => {
  //   setClear(true);
  //   setStatusFilter("");
  //   setMemberIdSearch("");
  //   setDateFilter({ fromDate: "", toDate: "", filterKey: "" });
  //   setFilteredData(null);
  //   setLastKey(null);
  // };

  const [filterState, setFilterState] = useState({
    cartOf: "",
    order_date: "",
    amountFrom: "",
    amountTo: "",
    status: "",
  });

  const resetFilterState = () => {
    setFilterState({
      cartOf: "",
      order_date: "",
      amountFrom: "",
      amountTo: "",
      status: "",
    });
    setFilterStates([]);
    onResetDate();
    setFilterActive(false);
    onReset();
    setIsInitalApiCall(true);
  };

  const headerMapping: Record<string, string> = {
    orderId: "Order ID",
    transactionNumber: "Transaction No",
    loyaltyNumber: "Loyalty Card No",
    type: "Type",
    totalAmount: "Total Amount",
    totalOrder: "Total Orders",
    orderDate: "Order Date",
    orderStatus: "Order Status",
    failureReason: "Failure Reason",
  };

  const formatCSVData = (data: any[]) => {
    const order = [
      "Order ID",
      "Transaction No",
      "Loyalty Card No",
      "Type",
      "Total Amount",
      "Total Orders",
      "Order Date",
      "Order Status",
      "Failure Reason",
    ];
    function sortByOrder(object: any, order: any) {
      const sortedObject: any = {};
      order?.forEach((key: any) => {
        if (object?.hasOwnProperty(key)) {
          sortedObject[key] = object[key];
        }
      });
      return sortedObject;
    }
    return data?.map((csvRow) => {
      const renamedRow = {
        ...csvRow,
      };
      const excludedColumns = ["navigateTo"];
      for (const key in renamedRow) {
        if (excludedColumns.includes(key)) {
          delete renamedRow[key];
        } else {
          if (headerMapping[key]) {
            renamedRow[headerMapping[key]] = renamedRow[key];
            delete renamedRow[key];
          }
        }
      }
      if (renamedRow.navigateTo) {
        delete renamedRow.id;
      }

      return sortByOrder(renamedRow, order);
    });
  };

  const handleExport = () => {
    setOpenExport(true);
  };
  const handleExportClose = () => {
    setOpenExport(false);
  };

  const isValidEmail = (email: any) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (emailRegex.test(email)) {
      setValidEmail(true);
    } else {
      setValidEmail(false);
    }
  };

  const HandleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setExportEmail(e.target.value);
    isValidEmail(e.target.value);
  };

  const handleLocalDownload = () => {
    // const exportableData = formatCSVData(
    //   filteredData ? filteredData : physicalVoucherData
    // );
    const exportableData = formatCSVData(earningsData);

    if (exportableData.length > 0) {
      const fields = Object.keys(exportableData[0]);
      const csvRows = [fields.join(",")];

      for (const row of exportableData) {
        const values = fields.map((field) => JSON.stringify(row[field]));
        csvRows.push(values.join(","));
      }

      const csvContent = `Report Title: Sales Listing \nExport Date: ${currentDate}\n${csvRows.join(
        "\n",
      )}`;
      const blob = new Blob([csvContent], { type: "text/csv" });
      const url = URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = "sales-listing.csv";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } else {
      console.error("No data to export");
    }
  };

  const HandleStatusChange = (event: SelectChangeEvent) => {
    getAllFields(
      "status",
      (event.target as HTMLSelectElement).value,
      operatorConstants.equal,
    );
    setFilterState((prev) => ({
      ...prev,
      status: event.target.value,
    }));
  };

  const amount = (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    getAllFields(
      "amount",
      `${filterState.amountFrom},${(event.target as HTMLInputElement).value}`,
      operatorConstants.between,
    );

    setFilterState((prev) => ({
      ...prev,
      amountTo: (event.target as HTMLInputElement).value,
    }));
  };

  const handleSendExport = async () => {
    const getFilterURL = getFilterParams();
    setSending(true);
    const handleExportFun = await exportData(
      getFilterURL,
      modelName.paymentGatewayOrder,
      hashKey.placeholderId,
      hashValue.allRecords,
    );
    handleExportFun.data.status && setEmailSent(true);
    setSending(false);
    setTimeout(() => {
      setEmailSent(false);
    }, 3000);
  };
  return (
    <Grid
      display={"flex"}
      flexDirection={"column"}
      width={"100%"}
      px={2}
      mt={2}
    >
      <Dialog onClose={handleClose} open={openFilter} sx={{ ml: "60vw" }}>
        <Grid sx={{ width: "484px", py: 4, px: 2 }}>
          <DialogTitle
            display={"flex"}
            justifyContent={"space-between"}
            borderBottom={theme.border?.smallGrey}
          >
            <Typography
              sx={{
                fontFamily: theme.font?.fontFamily.primary,
                color: theme.color?.primary,
                fontSize: theme.font?.fontSize.large,
                fontWeight: theme.font?.fontWeight.thicker,
              }}
            >
              Filter
            </Typography>
            <IconButton
              onClick={() => {
                setOpenFilter(false);
              }}
            >
              <CloseOutlinedIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={{ borderBottom: theme.border?.smallGrey }}>
            <Grid>
              <Grid borderBottom={theme.border?.smallGrey} mt={5} pb={3}>
                <Typography
                  sx={{
                    fontFamily: theme.font?.fontFamily.primary,
                    fontSize: theme.font?.fontSize.medium,
                    fontWeight: theme.font?.fontWeight.thick,
                  }}
                >
                  Type
                </Typography>
                <Grid
                  gap={2}
                  mt={2}
                  display={"flex"}
                  sx={{
                    width: "80%",
                  }}
                >
                  <FormControl
                    fullWidth
                    size="small"
                    sx={{
                      with: "100%",
                    }}
                  >
                    <Select
                      id=""
                      value={filterState.cartOf}
                      onChange={(e) => {
                        getAllFields(
                          "cartOf",
                          e.target.value,
                          operatorConstants.equal,
                        );
                        setFilterState((prev) => ({
                          ...prev,
                          cartOf: e.target.value,
                        }));
                      }}
                    >
                      {sourceList.map((name: any) => (
                        <MenuItem value={name}>{name}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>

              <Grid borderBottom={theme.border?.smallGrey} mt={3} pb={3}>
                <Typography
                  sx={{
                    fontFamily: theme.font?.fontFamily.primary,
                    fontSize: theme.font?.fontSize.medium,
                    fontWeight: theme.font?.fontWeight.thick,
                    marginBottom: "4px",
                  }}
                >
                  Total amount ($)
                </Typography>

                <Grid container alignItems="center" spacing={2}>
                  <Grid item xs={6} textAlign="left">
                    <Typography
                      sx={{
                        fontFamily: theme.font?.fontFamily.primary,
                        fontSize: theme.font?.fontSize.medium,
                        fontWeight: theme.font?.fontWeight.slightThick,
                      }}
                    >
                      From
                    </Typography>
                    <TextField
                      sx={{
                        display: "flex",
                        width: "100%",
                      }}
                      type="text"
                      size="small"
                      value={filterState.amountFrom}
                      onChange={(e) =>
                        setFilterState((prev) => ({
                          ...prev,
                          amountFrom: e.target.value,
                        }))
                      }
                      InputLabelProps={{
                        shrink: true,
                        focused: true,
                        style: {
                          color: "black",
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={6} textAlign="left">
                    <Typography
                      sx={{
                        fontFamily: theme.font?.fontFamily.primary,
                        fontSize: theme.font?.fontSize.medium,
                        fontWeight: theme.font?.fontWeight.slightThick,
                      }}
                    >
                      To
                    </Typography>
                    <TextField
                      sx={{
                        display: "flex",
                        width: "100%",
                      }}
                      type="text"
                      size="small"
                      value={filterState.amountTo}
                      onChange={(e) => {
                        amount(e);
                      }}
                      InputLabelProps={{
                        shrink: true,
                        focused: true,
                        style: {
                          color: "black",
                        },
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid borderBottom={theme.border?.smallGrey} mt={3} pb={3}>
                <DualInputProps
                  label="Order Date"
                  fromTitle="From"
                  fromOnChange={(data) => {
                    onUpdateFiltedDate(
                      OrderDate,
                      "fromDate",
                      data.target.value,
                    );
                  }}
                  fromValue={
                    selectedDates[OrderDate]?.fromDate?.toString() || ""
                  }
                  toTitle="To"
                  toOnChange={(data) => {
                    onUpdateFiltedDate(OrderDate, "toDate", data.target.value);
                  }}
                  toValue={selectedDates[OrderDate]?.toDate?.toString() || ""}
                  type="Date"
                />
              </Grid>

              <Grid mt={3} pb={3}>
                <Typography
                  sx={{
                    fontFamily: theme.font?.fontFamily.primary,
                    fontSize: theme.font?.fontSize.medium,
                    fontWeight: theme.font?.fontWeight.thick,
                  }}
                >
                  Status
                </Typography>
                <Grid
                  gap={2}
                  mt={2}
                  display={"flex"}
                  sx={{
                    width: "80%",
                  }}
                >
                  <FormControl
                    fullWidth
                    size="small"
                    sx={{
                      with: "100%",
                    }}
                  >
                    <Select
                      id=""
                      value={filterState.status}
                      onChange={HandleStatusChange}
                    >
                      {statusList.map((name: any) => (
                        <MenuItem value={name.value}>{name.key}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions sx={{ pr: 4, gap: 1, pt: 2 }}>
            <Button
              sx={{ ...buttonStyles.outlinedSecondary }}
              onClick={() => {
                resetFilterState();
              }}
            >
              Reset
            </Button>
            <Button
              sx={{ ...buttonStyles.containedSecondary }}
              onClick={handleApply}
            >
              Apply
            </Button>
          </DialogActions>
        </Grid>
      </Dialog>

      <ExportDialog
        closeDialog={setOpenExport}
        emailSent={emailSent}
        exportTitle="Sales Listing"
        handleClose={handleExportClose}
        open={openExport}
        sending={sending}
        handleSendExport={handleSendExport}
      />
      <Grid
        display={"flex"}
        gap={1}
        justifyContent={"end"}
        alignItems={"center"}
        px={2}
      >
        {getSalesListingPermission("export") && (
          <CommonButton
            buttonTitle="Export"
            variant="text"
            color="secondary"
            onClick={handleExport}
            disabled={!earningsData.length}
          />
        )}
        {getSalesListingPermission("download") && (
          <CommonButton
            buttonTitle="Download"
            variant="text"
            color="secondary"
            onClick={handleLocalDownload}
            disabled={!earningsData.length}
            endIcon={<DownloadForOfflineRoundedIcon />}
          />
        )}
        {getSalesListingPermission("read") && (
          <SearchInput
            HelpTip={SearchToolTip.SalesListing}
            onCallBack={handleSearch}
            ref={searchInputRef}
          />
        )}
        {getSalesListingPermission("read") && (
          <Button
            variant="text"
            startIcon={
              filterActive ? (
                <FilterAltIcon sx={{ color: theme.color?.secondary }} />
              ) : (
                <FilterAltOutlinedIcon />
              )
            }
            sx={{
              color: theme.color?.newFilterGrey,
              textTransform: "capitalize",
            }}
            onClick={() => {
              setOpenFilter(true);
            }}
          >
            Filter
          </Button>
        )}
      </Grid>
      {getSalesListingPermission("read") && (
        <InfiniteTable
          header={columns}
          contentItems={earningsData}
          hasMoreRecords={lastKey !== null}
          isInitialLoading={earningsData.length === 0 && loading}
          fetchMoreData={() => bindSearchAndFilter(true)}
          totalRecords={totalCount}
        />
      )}
    </Grid>
  );
};

export default Earnings;
